// Belge şablonu canlı önizleme (mini fatura). Klasik = varsayılan; diğerleri görünüm varyantı.
const DPV_CSS = `
.dpv { color:#0A0A0A; font-family:'Segoe UI',Arial,sans-serif; font-size:11px; background:#fff; border:1px solid #e2e8f0; border-radius:12px; overflow:hidden; padding:0 0 12px; }
.dpv-band { height:8px; background:var(--dp-primary); }
.dpv-band i { display:block; height:100%; width:38%; background:var(--dp-accent); }
.dpv-head { display:flex; justify-content:space-between; align-items:flex-start; gap:10px; padding:10px 12px 8px; }
.dpv-brand { font-size:14px; font-weight:800; color:var(--dp-primary); }
.dpv-sm { font-size:9.5px; color:#64748b; }
.dpv-title { font-size:18px; font-weight:800; letter-spacing:1px; color:var(--dp-primary); line-height:1; }
.dpv-tbl { width:calc(100% - 24px); margin:0 12px; border-collapse:collapse; border-radius:6px; overflow:hidden; }
.dpv-tbl th { background:var(--dp-primary); color:#fff; text-align:left; font-size:9.5px; padding:5px 7px; font-weight:600; }
.dpv-tbl td { border-bottom:1px solid #eef2f7; padding:5px 7px; font-size:10px; }
.dpv-tbl tbody tr:nth-child(even){ background:var(--dp-zebra); }
.dpv-tbl .r { text-align:right; }
.dpv-grand { margin:8px 12px 0; background:var(--dp-primary); border-radius:8px; padding:7px 10px; display:flex; justify-content:space-between; color:#fff; font-weight:800; font-size:11px; }
/* modern */
.dpv[data-tpl="modern"] .dpv-band { height:15px; }
.dpv[data-tpl="modern"] .dpv-band i { width:55%; }
.dpv[data-tpl="modern"] .dpv-title { font-size:21px; text-transform:uppercase; }
.dpv[data-tpl="modern"] .dpv-tbl th { text-transform:uppercase; letter-spacing:.6px; }
/* minimal */
.dpv[data-tpl="minimal"] .dpv-band { display:none; }
.dpv[data-tpl="minimal"] .dpv-title { color:#0A0A0A; }
.dpv[data-tpl="minimal"] .dpv-tbl th { background:#fff; color:#0A0A0A; border-bottom:2px solid #0A0A0A; }
.dpv[data-tpl="minimal"] .dpv-tbl tbody tr:nth-child(even){ background:#fff; }
.dpv[data-tpl="minimal"] .dpv-grand { background:#0A0A0A; }
/* zarif */
.dpv[data-tpl="zarif"] { font-family:'Georgia','Times New Roman',serif; }
.dpv[data-tpl="zarif"] .dpv-band { height:4px; }
.dpv[data-tpl="zarif"] .dpv-title { font-weight:700; letter-spacing:3px; }
.dpv[data-tpl="zarif"] .dpv-tbl th { background:var(--dp-soft); color:var(--dp-primary); border-bottom:2px solid var(--dp-primary); }
/* kompakt */
.dpv[data-tpl="kompakt"] { font-size:9.5px; }
.dpv[data-tpl="kompakt"] .dpv-head { padding:6px 10px 5px; }
.dpv[data-tpl="kompakt"] .dpv-title { font-size:15px; }
.dpv[data-tpl="kompakt"] .dpv-tbl th { padding:3px 6px; font-size:8.5px; }
.dpv[data-tpl="kompakt"] .dpv-tbl td { padding:3px 6px; font-size:9px; }
/* kurumsal */
.dpv[data-tpl="kurumsal"] { border:2px solid var(--dp-primary); }
.dpv[data-tpl="kurumsal"] .dpv-band { display:none; }
.dpv[data-tpl="kurumsal"] .dpv-head { border-bottom:3px double var(--dp-primary); }
.dpv[data-tpl="kurumsal"] .dpv-brand { text-transform:uppercase; letter-spacing:.5px; }
.dpv[data-tpl="kurumsal"] .dpv-title { border:2px solid var(--dp-primary); padding:2px 8px; border-radius:4px; font-size:15px; }
/* premium */
.dpv[data-tpl="premium"] .dpv-band { height:16px; }
.dpv[data-tpl="premium"] .dpv-band i { width:100%; background:var(--dp-accent); }
.dpv[data-tpl="premium"] .dpv-title { letter-spacing:1.5px; }
.dpv[data-tpl="premium"] .dpv-tbl th { border-bottom:2px solid var(--dp-accent); }
.dpv[data-tpl="premium"] .dpv-grand { border:1px solid var(--dp-accent); }
/* ferah */
.dpv[data-tpl="ferah"] .dpv-band { height:3px; }
.dpv[data-tpl="ferah"] .dpv-head { padding:16px 12px 12px; }
.dpv[data-tpl="ferah"] .dpv-tbl th { background:var(--dp-soft); color:var(--dp-primary); }
.dpv[data-tpl="ferah"] .dpv-tbl td { padding:8px 7px; }
.dpv[data-tpl="ferah"] .dpv-grand { background:var(--dp-soft); color:var(--dp-primary); border:1px solid var(--dp-primary); }
/* kutu */
.dpv[data-tpl="kutu"] .dpv-band { display:none; }
.dpv[data-tpl="kutu"] .dpv-head { border:1.5px solid var(--dp-primary); border-radius:8px; margin:10px 12px 0; padding:8px 10px; }
.dpv[data-tpl="kutu"] .dpv-tbl { border:1.5px solid var(--dp-primary); }
.dpv[data-tpl="kutu"] .dpv-grand { border:1.5px solid var(--dp-primary); }
`;

export function DocTemplatePreview({ template = "klasik", theme }) {
  const th = theme || {};
  const vars = {
    "--dp-primary": th.primary || "#064E3B",
    "--dp-accent": th.accent || "#EA580C",
    "--dp-soft": th.primarySoft || "#ECFDF5",
    "--dp-zebra": th.zebra || "#f6fdfa",
  };
  return (
    <div>
      <style>{DPV_CSS}</style>
      <div className="dpv" data-tpl={template} style={vars} data-testid="doc-template-preview">
        <div className="dpv-band"><i /></div>
        <div className="dpv-head">
          <div>
            <div className="dpv-brand">Groot Market</div>
            <div className="dpv-sm">Groot Games Teknoloji A.Ş.</div>
            <div className="dpv-sm">VKN: 1234567890</div>
          </div>
          <div className="dpv-title">FATURA</div>
        </div>
        <table className="dpv-tbl">
          <thead><tr><th>Ürün / Hizmet</th><th className="r">Adet</th><th className="r">Tutar</th></tr></thead>
          <tbody>
            <tr><td>Ürün A</td><td className="r">2</td><td className="r">49,80</td></tr>
            <tr><td>Ürün B</td><td className="r">1</td><td className="r">12,50</td></tr>
          </tbody>
        </table>
        <div className="dpv-grand"><span>GENEL TOPLAM</span><span>62,30 ₺</span></div>
      </div>
    </div>
  );
}
